// LoadingState.jsx
// Loading state component for ListingDetails

import React from 'react';
import { styles } from './styles';

const LoadingState = () => {
  return (
    <div style={styles.loadingContainer}>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingState;